import { ScrollReveal } from '@/components/ui/scroll-reveal';

export function TeamSection() {
  return (
    <section className="relative py-28 bg-charcoal overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <ScrollReveal className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-electric" />
            <span className="text-electric font-display tracking-[0.4em] text-xs">// THE CREW</span>
            <span className="h-[2px] w-10 bg-electric" />
          </div>
          <h2 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            THE <span className="text-thunder">THUNDER</span> TEAM
          </h2>
          <p className="text-white/60 text-lg mt-6 max-w-2xl mx-auto">
            Trained. Background-checked. Obsessed with the details. Meet the people making your space pass inspection.
          </p>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-0 relative">
          <ScrollReveal direction="left" className="relative overflow-hidden aspect-[4/5] group">
            <img
              src="/images/heroes/hero-2-team-action.webp"
              alt="SOTSVC team in action"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div
              className="absolute inset-0"
              style={{ background: 'linear-gradient(180deg, transparent 40%, rgba(15,15,30,.95) 100%)' }}
            />
            <div className="absolute bottom-0 left-0 p-8">
              <div className="text-thunder font-display tracking-[0.3em] text-xs mb-2">// IN ACTION</div>
              <h3 className="font-display font-bold text-white text-4xl">We Show Up.</h3>
              <p className="text-white/70 mt-2">On time. In uniform. Ready to work.</p>
            </div>
          </ScrollReveal>

          <div
            className="hidden md:block absolute left-1/2 top-0 bottom-0 -translate-x-1/2 w-px z-[2]"
            style={{ background: 'linear-gradient(180deg, transparent, #ffd60a, transparent)' }}
          />

          <ScrollReveal direction="right" className="relative overflow-hidden aspect-[4/5] group">
            <img
              src="/images/heroes/hero-4-thumbs-up.webp"
              alt="SOTSVC crew thumbs up"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div
              className="absolute inset-0"
              style={{ background: 'linear-gradient(180deg, transparent 40%, rgba(15,15,30,.95) 100%)' }}
            />
            <div className="absolute bottom-0 right-0 p-8 text-right">
              <div className="text-electric font-display tracking-[0.3em] text-xs mb-2">// THE RESULT</div>
              <h3 className="font-display font-bold text-white text-4xl">You Smile.</h3>
              <p className="text-white/70 mt-2">Every time. Or we come back.</p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
